define(function (require) {
    var $ = require("jquery");
    var utils = require("@modules/utils");

    function getAjaxPostRequest(data) {
        return {
            type: "post",
            data: data,
            headers: {
                RequestVerificationToken: utils.getRequestVerificationToken()
            }
        };
    }

    return {
        validateUrl: function (url) {
            var parameters = {
                returnUrl: url
            };
            return $.ajax("/api/ReturnUrlWhitelist/Validate", getAjaxPostRequest(parameters)).then(function (results) {
                return results;
            });
        }
    };
});
